import styled from "styled-components";
import { SwiperContainer } from "styles/general_styles";

export const CustomSwiperContainer = styled(SwiperContainer)`
	.swiper-pagination {
		margin-top: 30px;
	}
`;
